import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsPage() {
    const navigate = useNavigate();

    return (
        <div className="bg-gray-50 min-h-screen py-10">
            <div className="mx-auto max-w-3xl bg-white p-6 md:p-12 shadow-sm rounded-2xl">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-8 flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
                >
                    <ArrowLeft size={16} />
                    Volver
                </button>

                <div className="text-gray-700 leading-relaxed text-sm md:text-base space-y-6">
                    <h1 className="text-3xl font-extrabold text-gray-900 mb-8">⚖️ Términos y Condiciones de Uso</h1>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">1. Objeto del Servicio</h2>
                        <p>
                            Zovy Rewards es una plataforma tecnológica que permite a los usuarios acumular puntos y canjear premios en los comercios adheridos. Zovy Solutions proporciona únicamente la infraestructura técnica.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">2. Naturaleza de los Puntos y Premios</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li><strong>Sin valor monetario:</strong> Los puntos acumulados en la aplicación no tienen valor en dinero real, no pueden ser intercambiados por efectivo, ni pueden ser transferidos a las cuentas de otros usuarios.</li>
                            <li><strong>Responsabilidad del Comercio:</strong> Los premios, descuentos y regalos son ofrecidos exclusivamente por el comercio (Franquicia). Zovy Solutions no se hace responsable si un comercio cierra, se retira de la plataforma o modifica su catálogo de premios.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">3. Caducidad de los Puntos</h2>
                        <p>
                            Cada comercio adherido a la plataforma tiene la potestad de establecer sus propias reglas de caducidad por inactividad. La aplicación informará al usuario de la política de caducidad aplicable en el panel de su "Cartera". Si los puntos caducan según las reglas del comercio, no podrán ser recuperados.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">4. Obligaciones del Usuario</h2>
                        <p>
                            El usuario se compromete a hacer un uso lícito de la aplicación. Cualquier intento de fraude, manipulación del sistema de generación de códigos (OTP), creación de cuentas falsas para el sistema de referidos o abuso del sistema resultará en la cancelación inmediata de la cuenta y la pérdida total de los puntos.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 mb-3">5. Modificaciones y Cancelación</h2>
                        <p>
                            Zovy Solutions se reserva el derecho de modificar estos términos, el diseño de la aplicación o suspender el servicio en cualquier momento. Los comercios también se reservan el derecho a cambiar el coste en puntos de sus premios sin previo aviso.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
